<template>
  <section class="">
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fit">#</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">名稱 (ID)</th>
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">縮寫</th>-->
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">電話</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fat">地址</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fit">營業狀態</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fit">接單狀態</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fit">連線狀態</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fit">今日連線紀錄</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fit" v-if="roleType != 10">查詢連線紀錄</th>
          </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr>
              <td colspan="12" class="text-center">資料讀取中......</td>
            </tr>
          </tbody>
          <tbody v-else-if="storeList.length === 0">
            <tr style="background-color: white">
              <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="storeList.length > 0">
          <tr class="even" role="row" v-for="(store, index) in storeList">
            <!-- column 0 -->
            <td class="sorting_1">
              {{index + 1}}
            </td>
            <td>
              <span>{{store.name}} ({{store.id}})</span>
            </td>
            <!-- column 3 -->
            <!--<td>{{store.name_short}}</td>-->
            <!-- column other-->
            <td v-if="!history">{{store.tel}} <br> {{store.tel2}}</td>
            <td v-if="!history">{{store.address}}</td>
            <td>
              <span v-if="store.status == 2" class="label label-success">{{getStateName(store.status)}}</span>
              <span v-if="store.status != 2"  class="label label-danger">{{getStateName(store.status)}}</span>
            </td>
            <td>
              <div v-if="roleType !== 50">
                <div data-toggle="modal" data-target="#closeStatusModal" @click="openModal(store)" class="c-pointer">
                  <span v-if="store.order_status  == 10" class="label label-success">接單中</span>
                </div>
                <div data-toggle="modal" data-target="#openStatusModal" @click="openModal(store)" class="c-pointer">
                  <span v-if="store.order_status  == 20"  class="label label-danger">未接單</span>
                </div>
              </div>
              <div v-if="roleType === 50">
                <span v-if="store.order_status  == 10" class="label label-success">接單中</span>
                <span v-if="store.order_status  == 20"  class="label label-danger">未接單</span>
              </div>
            </td>
            <td>
              <span v-if="!store.mqtt_info" class="label label-default">無紀錄</span>
              <span  v-if="store.mqtt_info" >
                <span v-if="store.mqtt_info[0].status === 2"  class="label label-danger">中斷</span>
                <span v-if="store.mqtt_info[0].status === 1" class="label label-success">連線</span>
              </span>
            </td>
            <td><button class="btn btn-default" data-toggle="modal" data-target="#mqttModal" @click="openModal(store)" v-if="store.mqtt_info"><i class="fa fa-plug" aria-hidden="true"></i></button></td>
            <td v-if="roleType != 10"><button class="btn btn-default" @click="gotoSearchMqtt(store)"><i class="fa fa-search" aria-hidden="true"></i></button></td>
          </tr>
          </tbody>
        </table>
      </div>
      <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                :groupAmount="groupAmount" :clickPage="clickPage"
      >
      </paginate>
    </div>

    <div class="modal fade" role="dialog" id="mqttModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{current.name}}今日連線紀錄</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">時間</th>
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">連線狀態</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="even" role="row" v-for="(mqtt, index) in current.mqttInfo">
                    <td>
                      {{getTime(mqtt.create_time)}}
                    </td>
                    <td>
                      <span v-if="mqtt.status === 1" class="label label-success">建立</span>
                      <span v-if="mqtt.status === 2"  class="label label-danger">中斷</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <m-modal :option="openStatusOption" @trigger="trigger"></m-modal>
    <m-modal :option="closeStatusOption" @trigger="trigger"></m-modal>
  </section>
</template>

<script>
import $ from 'jquery'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import matcherModal from '../../../elements/Modal.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  props: ['brandId', 'search'],
  name: 'Tables',
  components: {
    'm-modal': matcherModal
  },
  data () {
    return {
      roleType: 0,
      name: '迷客夏',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 20,
      history: false,
      storeList: [],
      current: {
        openList: {},
        deliveryList: {},
        payList: {},
        name: '',
        mqttInfo: [],
        storeId: 0
      },
      openStatusOption: {
        id: 'openStatusModal',
        title: '',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '開啟接單',
            event: 'openStatus'
          }
        ]
      },
      closeStatusOption: {
        id: 'closeStatusModal',
        title: '',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '停止接單',
            event: 'closeStatus'
          }
        ]
      },
      isLoading: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      })
    })
  },
  methods: {
    trigger (event) {
      // console.log(event)
      if (event === 'openStatus') {
        this.changeStatus('open')
      } else if (event === 'closeStatus') {
        this.changeStatus('close')
      }
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    getStateName (state) {
      if (state === 0) {
        return '尚未營業'
      } else if (state === 1) {
        return '籌備中'
      } else if (state === 2) {
        return '營業中'
      } else if (state === 3) {
        return '休息中'
      } else if (state === 9) {
        return '已歇業'
      }
    },
    getDayName (day) {
      if (day === 1) {
        return '日'
      } else if (day === 2) {
        return '一'
      } else if (day === 3) {
        return '二'
      } else if (day === 4) {
        return '三'
      } else if (day === 5) {
        return '四'
      } else if (day === 6) {
        return '五'
      } else if (day === 7) {
        return '六'
      }
    },
    getStoreList () {
      this.isLoading = true
      var self = this
      var data = {
        page: this.tableIndex,
        size: this.count
      }
      var url = '/brand/' + this.brandId + '/storeList?page=' + data.page + '&size=' + data.size
      if (this.search.type === 1 && this.search.val) url = url + '&name=' + this.search.val
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeList = response.data.list
          self.isLoading = false
          self.total = response.data.list_total
        }
      })
    },
    openModal (store) {
      this.current.storeId = store.id
      this.current.openList = store.opening_info
      this.current.deliveryList = store.delivery_info
      this.current.payList = store.trade_info
      this.current.name = store.name
      this.current.mqttInfo = store.mqtt_info
      this.openStatusOption.title = '是否開啟' + this.current.name + '店家狀態？'
      this.closeStatusOption.title = '是否關閉' + this.current.name + '店家狀態？'
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getStoreList()
    },
    getTime (time) {
      return moment(time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss')
    },
    gotoSearchMqtt (store) {
      this.$router.push({path: 'mqttSearch/' + store.id})
    },
    changeStatus (active) {
      var self = this
      var data = {
        order_status: 10
      }
      if (active === 'close') {
        data.order_status = 20
      }
      var url = '/store/' + this.current.storeId
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: '接單狀態更新成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.tableIndex = 1
          self.getStoreList()
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  created () {
    this.roleType = parseInt(this.getRoleType, 10)
  },
  watch: {
    brandId () {
      if (this.brandId) {
        this.tableIndex = 1
        this.getStoreList()
      }
    },
    'search.status' () {
      if (this.search.status) this.getStoreList()
      this.search.status = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// MqttTableTemp.vue?66369942